<template>
  <div>
    <h1>Importar Recursos</h1>
    <b-card>
      <FormImportarEmendas @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import FormImportarEmendas from "../Components/FormImportarEmendas.vue";

export default {
  components: { FormImportarEmendas },
  methods: {
    async loadData(id) {
    },
  },
  async created() {},
};
</script>

<style></style>
